import { IncidentAttackInfoWebComponent } from './component/IncidentAttackInfoWebComponent';
import { CategoriesList } from '../../incidentsGrid/types';

export { IncidentAttackInfoWebComponent };

export interface ProcessedData {
  resources?: Array<CategoriesList>;
  entities?: Array<CategoriesList>;
}
